import React from 'react'

import '../../../styles/sortableData.scss'
import '../../../styles/contractsList.scss'
import ContractsComponent from './ContractsComponent'

const ContractsVencimientos: React.FC = () => {
  return (
    <>
      <ContractsComponent></ContractsComponent>
    </>
  )
}

export default ContractsVencimientos
